var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"bold mb-1"},[_vm._v(_vm._s(_vm.label))]),_c('div',[_c('span',[_vm._v("Months (0-60)")]),_c('input',{staticClass:"input ml-2",attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }